import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

import { TrackingInfo } from '../../models/tracking-info.model';

const COMPANIES = [
  'CJ대한통운',
  '우체국택배',
  '한진택배',
  '롯대택배',
  '로젠택배',
];

@Component({
  selector: 'app-tracking-info-form',
  templateUrl: './tracking-info-form.component.html',
  styleUrls: ['./tracking-info-form.component.scss'],
})
export class TrackingInfoFormComponent implements OnInit {
  @Input() defaultCompany: string;
  @Input() initialValue: TrackingInfo;

  public readonly _companies = COMPANIES;
  public _useCustomCompany = false;
  public _defaultCompany: string;

  public _formGroup: FormGroup;

  constructor(private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this._formGroup = this.formBuilder.group({
      company_name: [
        this.initialValue?.company_name || '',
        Validators.required,
      ],
      invoice_no: [this.initialValue?.invoice_no || '', Validators.required],
    });

    let defaultCompany;

    if (this.initialValue) {
      defaultCompany = this.initialValue.company_name;
    } else if (this.defaultCompany) {
      defaultCompany = this.defaultCompany;
    }

    if (defaultCompany) {
      this._setCompany(defaultCompany);
      this._defaultCompany = this._useCustomCompany ? '' : defaultCompany;
    }
  }

  _onCompanySelectionChange(event: MatSelectChange): void {
    this._setCompany(event.value, true);
  }

  _setCompany(company: string, markAsDirty?: boolean): void {
    this._useCustomCompany = !this._companies.find((c) => c === company);
    this._formGroup.get('company_name').setValue(company);
    if (markAsDirty) {
      this._formGroup.get('company_name').markAsDirty();
    }
  }

  get value(): TrackingInfo {
    return this._formGroup.getRawValue();
  }

  get invalid(): boolean {
    return this._formGroup.invalid;
  }

  get pristine(): boolean {
    return this._formGroup.pristine;
  }
}
